<template>
  <wtFormRight>
    <!-- -TOOLBARS -->
    <template slot="toolbars">
      <Toolbars
        :objProps="objItem"
        :objPropsData="objItemData"
        :urlServices="urlServices"
        :primary_key="primary_key"
        :nameObjData="nameObjData"
        :requiredEndDt="requiredEndDt"
        :noDelete="noDelete"
      />
    </template>

    <!-- VIEW TABLE -->
    <template slot="table" v-if="showGrid">
      <SecurityCredentialGrid @selectedSecurityCredential="objRowSelected = $event"></SecurityCredentialGrid>
    </template>

    <!-- VIEW FORM -->
    <template slot="form" v-if="!showGrid">
      <div class @contextmenu.prevent="$refs.menu.open($event, contextMenu)">
        <b-form class="text-uppercase">
          <!-- Line 01 -->
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="security_credential_access_key">access_key</label>

              <input
                type="text"
                class="form-control"
                id="security_credential_access_key"
                :readonly="typeof objItem.security_credential_id !== 'undefined'"
                v-model.trim="objItem.access_key"
              />
            </div>

            <div class="form-group col-md-6">
              <label for="security_credential_secret_key">secret key</label>
              <input
                type="password"
                class="form-control"
                id="security_credential_secret_key"
                v-model.trim="objItemData.secret_key"
              />
            </div>
          </div>

          <!-- Line 02 -->
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="security_credential_security_provider_id">Security Provider</label>
              <SecurityProviderFind
                @securityProviderFind="securityProviderFind=$event"
                :getSecurityProvider="securityProviderFind"
                :urlOrigem="urlServices"
              />
            </div>

            <div class="form-group col-md-6">
              <label for="security_credential_autentication_type">autentication type</label>
              <b-form-select
                id="security_credential_autentication_type"
                class="form-control"
                :options="autenticationType"
                v-model="objItemData.autentication_type"
              />
            </div>
          </div>

          <!-- Line 03 -->
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="security_credential_credential_type">credential type</label>
              <b-form-select
                id="security_credential_credential_type"
                class="form-control"
                :options="credentialType"
                v-model="objItemData.credential_type"
              />
            </div>

            <div class="form-group col-md-3">
              <label for="security_credential_init_dt">init dt</label>
              <input
                type="date"
                class="form-control"
                id="security_credential_init_dt"
                v-model.trim="objItemData.init_dt"
              />
            </div>

            <div class="form-group col-md-3">
              <label for="security_credential_end_dt">end dt</label>
              <input
                type="date"
                class="form-control"
                id="security_credential_end_dt"
                readonly
                v-model.trim="objItemData.end_dt"
              />
            </div>
          </div>
          <input type="hidden" id="security_roles_id" v-model="objItemData.security_roles_id" />
          <SecurityRoleSelect
            :base_id="objItem.security_credential_id"
            :role_list="objItemData.security_roles_id"
            @roleIdList="updateRole"
          ></SecurityRoleSelect>
          <!--<pre style="text-transform: lowercase">{{objItem}}</pre>-->
        </b-form>
        <!-- Context Menu -->
        <ContextMenu ref="menu">
          <template slot-scope="{}">
            <ContextMenuItem
              v-for="(item, index) in contextMenu.actions"
              :key="index"
              @click.native="$refs.menu.executeAction(index)"
            >{{ item.action }}</ContextMenuItem>
          </template>
        </ContextMenu>
      </div>
    </template>
  </wtFormRight>
</template>
<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/* COMPONENTS - LAYOUT */
import wtFormRight from "@/components/forms/wtFormRight";
import Toolbars from "@/components/widgets/Toolbars";
import ContextMenu from "@/components/widgets/context-menu/ContextMenu";
import ContextMenuItem from "@/components/widgets/context-menu/ContextMenuItem";

/* COMPONENTS - PAGE */
import SecurityCredentialGrid from "./SecurityCredentialGrid";
import SecurityProviderFind from "@/modules/security_ds/internal/security_provider/SecurityProviderFind";
import SecurityRoleSelect from "@/modules/security_ds/internal/security_role/SecurityRoleSelect";

export default {
  name: "SecurityCredential",
  props: {
    autenticationType: Array,
    credentialType: Array
  },
  /* COMPONENTS IN USE */
  components: {
    wtFormRight,
    Toolbars,
    ContextMenu,
    ContextMenuItem,
    SecurityCredentialGrid,
    SecurityProviderFind,
    SecurityRoleSelect
  },

  /* COMPUTED VARIABLES */
  computed: {
    showGrid() {
      return this.$store.state.layout.showGrid;
    },
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
    objShared() {
      return this.$store.state.objShared;
    },
    objSelected() {
      return this.$store.state.objSelected;
    },
    action() {
      return this.$store.state.action;
    }
  },

  /* VARIABLES */
  data: function() {
    return {
      /* Controls */
      urlServices: "security-ds/api/internal/security-credential",
      primary_key: "security_credential_id",

      /* Objects Page */
      objItem: {},
      objItemData: {},
      objRowSelected: {},
      nameObjData: "security_credential_data",
      requiredEndDt: true,
      noDelete: false,

      /* Others Query */
      securityProviderFind: {},

      /* Context Menu Options */
      contextMenu: {
        row: [],
        actions: []
      },
      contextMenuOptions: [
        {
          action: "Active Credential",
          urlAction:
            "security-ds/api/internal/security-credential/activate-credential",
          key: "security_credential_id"
        }
      ]
    };
  },

  /* METHODS */
  methods: {
    load(objItem) {
      this.$store.commit("setShowLoading", true);
      this.$store.commit("setShowGrid", false);

      const param = {};
      param[`${this.primary_key}`] = objItem[`${this.primary_key}`];
      const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find/`;

      axios.post(url, param).then(res => {
        this.objItem = res.data[0];
        this.objItemData = this.objItem[`${this.nameObjData}`];
        this.getSecurityProvider();
        this.updateActionContextMenu();
        this.$store.commit("setShowLoading", false);
      });
    },

    getSecurityProvider() {
      const securityProvider = {};
      securityProvider.security_provider_id = this.objItemData.security_provider_id;

      const url = `${baseApiUrl}:${baseApiPort}/security-ds/api/internal/security-provider/find`;
      axios.post(url, securityProvider).then(res => {
        this.securityProviderFind = res.data[0];
      });
    },

    getAutenticationType() {
      const urlService = "security-ds/api/internal/security-credential/";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-authentication-types`
        )
        .then(res => {
          res.data.forEach(element => {
            this.autenticationType.push({
              value: element[0],
              text: element[1]
            });
          });
        });
    },
    getCredentialType() {
      const urlService = "security-ds/api/internal/security-credential/";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-credential-types`
        )
        .then(res => {
          res.data.forEach(element => {
            this.credentialType.push({
              value: element[0],
              text: element[1]
            });
          });
        });
    },

    updateActionContextMenu() {
      const options = [];
      if (this.objItemData.end_dt !== null) {
        options.push(this.contextMenuOptions[0]);
      }
      this.contextMenu.row = this.objItem;
      this.contextMenu.actions = options;
    },
    updateRole(payload) {
      this.objItemData.security_roles_id = payload;
    }
  },

  /* WATCH */
  watch: {
    objRowSelected() {
      this.load(this.objRowSelected);
      this.$store.commit("setAction", "modify");
    },
    objSelected() {
      if (this.urlServicesStore === this.urlServices) {
        if (Object.entries(this.objSelected).length === 0) {
          this.$emit("securityCredentialSelected", null);
        } else {
          this.$emit("securityCredentialSelected", this.objSelected.access_key);
        }
      }
    },
    action() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.action === "reset") {
          this.objItem = {};
          this.objItemData = {};
        }
      }
    },
    securityProviderFind() {
      this.objItemData.security_provider_id = this.securityProviderFind.security_provider_id;
    }
  },

  /* LIFE CICLE */
  mounted() {}
};
</script>